import moment from "moment";
import React from "react";
import { IIdLibelle } from "../models/interfaces/IIdLibelle";

export const ServiceApplication_Key = "943F8623296751EE1767C37385E651E92AE46809ECDE7E79282474DDE36CABFA";

 // eslint-disable-next-line no-useless-escape
export const passwordRegex = /(?!.*?%)(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[$!*#?&+\-=@^_()\/\\€]).{8,}/; 
//==>interdit le %
export const matchingNumber = /^(\s*|\d+)$/;
export const matchingDecimal = /^(([+]?(\d*([.,]\d{1,2})?))|\s*)$/
export const matching_cheiffreromain = /(^(?=[MDCLXVI])M*(C[MD]|D?C{0,3})(X[CL]|L?X{0,3})(I[XV]|V?I{0,3})$)/;

export const isEmpty = (value: unknown): boolean =>
  value === undefined ||
  value === null ||
  (typeof value === "object" && Object.keys(value).length === 0) ||
  (typeof value === "string" && value.trim.length === 0);

export const aWeekAgo = (): Date => {
  const date = new Date();
  date.setDate(date.getDate() - 7);
  return date;
};

// export const formatDate = (date:Date) => {
//   const year = date.getFullYear();
//   const month = (date.getMonth() + 1).toString().padStart(2, '0'); // +1 car les mois commencent à 0
//   const day = date.getDate().toString().padStart(2, '0');

//   return `${year}${month}${day}`;
// };



export const SourcesModifiable = [
  { Libelle: "electre" },
  { Libelle: "hachette-colo-papet" },
  { Libelle: "interforum-colo-papet" },
];

//export const ModificationDemande encours??? 
export const ModificationBloque = (pSource:string, pSupportId:string,pReturnPrefixe:string): JSX.Element|undefined => {
//numérique
  if (pSupportId.length > 0 && pSupportId[0].toLowerCase() === "i") {
    return <div>
              {pReturnPrefixe}
              <br/>
              Merci de vous rapprocher de votre e-distributeur pour effectuer vos modifications.
            </div>;
  }
//LPE
  if (pSource.length > 0 && pSource.trim().toLowerCase() === "lpe") {
    return <div>
              {pReturnPrefixe} 
              <br/>
              Merci d&apos;utiliser le portail&nbsp;
              <a href="https://www.lespetitsediteurs.fr" target="_blank" rel="noopener noreferrer">lespetitsediteurs.fr</a> 
              &nbsp;pour effectuer vos modifications.
            </div>;
 }
//Source pas dans liste blanche
  if (pSource.length < 1 || pSource.length > 0 && !SourcesModifiable.some(item => item.Libelle === pSource)) {
    return <div>
            {pReturnPrefixe}
            <br/>Merci de vous rapprocher de votre fournisseur de données
            </div>;
  }
  
  //Sinon OK !
  return undefined;
}
export const TypeCompteSociete = [
  { Id: 1, Libelle: "Editeur" },
  { Id: 2, Libelle: "Diffuseur / Distributeur" },
  { Id: 3, Libelle: "Administrateur" }, 
  { Id: 4, Libelle: "Autre périmètre" },
];

export const ModulesList = [
  { Id: 1, Libelle: "Gestion de votre catalogue" },
  { Id: 2, Libelle: "Alerte Poche" },
  { Id: 3, Libelle: "Electre Data Expert" },
  { Id: 4, Libelle: "Electre Data Control" },
  { Id: 5, Libelle: "Achat de fichiers" },
  { Id: 6, Libelle: "Actualisation du référencement" }
]


export enum ContactSujetIds {
  Connexion=1,
  MonCompte=2,
  GestionDeVotreCatalogue=3,
  AlertePoche=4,
  ElectreDataControl=5,
  ElectreDataExpert=6, 
  AchatDeFichiers=7,
  ActualisationDuReferencement=8,
  Autres=9
}



export enum Modules {
  GestionDeVotreCatalogue = "Gestion de votre catalogue",
  AlertePoche = "Alerte Poche",
  ElectreDataExpert = "Electre Data Expert",
  ElectreDataControl = "Electre Data Control",
  AchatDeFichiers="Achat de fichiers",
  ActualisationDuReferencement="Actualisation du référencement"

}

export enum ModulesIds {
  ReferencementElectre = 1,
  AlertePoche = 2,
  ElectreDataExpert = 3,
  ElectreDataControl = 4
}


export const AdefinirList = [
  { Id: 1, Libelle: "Item 1" },
  { Id: 2, Libelle: "Item 2" },
  { Id: 3, Libelle: "Item 3" },
];

export enum validationMode {
  "none",
  "classic",
  "invalid",
}

export const validationClass = (errors:any, isValid:boolean) => {
  if (errors) {
    return "is-invalid";
  } else if (isValid) {
    return "is-valid";
  } else {
    return "";
  }
};

export function isInvalidClass(errors:any) {
  return errors && "is-invalid";
}


// export enum MessageTypeAffichage {
//   FullScreen = 1,
//   Minimal = 2
// }

export enum MessageTypeView {
  Demande = 1,
  Reponse =2
}

export enum MessageTypeDemande {
  Notice = 1,
  Societe =2
  }

export function isNumeric(value:any) {
  return !isNaN(value - parseFloat(value));
}


/** typeDemandeNMarqueMessage */
export const typeDemandeMessageListMarques = [
  { Id: 1, Libelle: "Informations commerciales", },
];

export const enum Type_Demande_Marque_Message {
  InformationsCommerciales = 1,
}
/** ****** */

/** typeDemandeNoticeMessage */
export const typeDemandeMessageListNotices = [
  { Id: 2, Libelle: "Titre"},
  { Id: 3, Libelle: "Auteur(s)"},
  { Id: 4, Libelle: "Date de parution"},
  { Id: 5, Libelle: "Disponibilité"},
  { Id: 6, Libelle: "Collection(s)"},
  { Id: 7, Libelle: "Thématique(s) / indexation(s)"},
  { Id: 8, Libelle: "Résumé"},
  { Id: 9, Libelle: "Format"},
  { Id: 10, Libelle: "Nouvelle édition"},
  { Id: 11, Libelle: "Abandon de projet"},
  { Id: 12, Libelle: "1re de couverture"},
  { Id: 13, Libelle: "4e de couverture"},
  { Id: 14, Libelle: "Table des matières"},
  { Id: 15, Libelle: "Autre"},
];

export const typeDemandeNoticeDemandeListNotices = [
  { Id: "hauteur",Libelle: "Hauteur"},
  { Id: "largeur",Libelle: "Largeur"},
  { Id: "epaisseur",Libelle: "Epaisseur"},
  { Id: "poids",Libelle: "Poids"},
  { Id: "nbpages",Libelle: "Nombre de pages"},
  { Id: "disponibilite",Libelle: "Disponibilité"},
  { Id: "prixttc",Libelle: "Prix TTC"},
  //{ Id: "devise",Libelle: "Devise"},
  { Id: "dateparution",Libelle: "Date de parution"},
];


export const enum Type_Demande_Notice_Message {
  Titre = 1,
  Auteur = 2,
  DateDeParution = 3,
  Disponibilite =4,
  Prix =5,
  Collection =6,
  ThematiqueIndexation =7,
  Resume =8,
  Format =9,
  NouvelleEdition =10,
  AbandonProjet =11,
  PremierDeCouverture =12,
  QuatriemeDeCouverture =13,
  TableDesMatieres =14,
  Autre =15,
}
/** ****** */


export function getLibelleByIdInIIdLibelle(id:number,list:IIdLibelle[]) {
  const item = list.find(l => l.Id === id);
  return item ? item.Libelle : "-";
}


export const enum Notice_Demande_Modification_Etat {
  Cree = 1,
  Encoursdetraitement = 2,
  Traite = 3,
  Annule =4,
  Erreur=5
}


export const NoticeDemandeModificationEtatList = [
  { Id: 1, Libelle: "Créé" },
  { Id: 2, Libelle: "En cours de traitement" },
  { Id: 3, Libelle: "Traité" }, 
  { Id: 4, Libelle: "Annulé" }, 
  { Id: 5, Libelle: "Erreur" }, 
];

export const SecteurActiviteCompteSocieteList = [
  { Id: 1, Libelle:	"Editeur à compte d'éditeur" },
  { Id: 2, Libelle:	"Diffuseur et/ou Distributeur" },
  { Id: 3, Libelle:	"Auteur - éditeur" },
  { Id: 4, Libelle:	"Editeur à compte d'auteur" },
  { Id: 5, Libelle:	"Editeur de livres à la demande" },
  { Id: 6, Libelle:	"Association" },
  { Id: 7, Libelle:	"Centre culturel - musée" },
  { Id: 8, Libelle:	"Collectivité locale ou territoriale - Autre" },
];

export const TypeCompteSocieteList = [
  { Id: 1, Libelle: "Editeur" },
  { Id: 2, Libelle: "Diffuseur" },
  { Id: 3, Libelle: "Administrateur" },
];

/** typeReponseMessage */
export const typeReponseMessageList = [
  { Id: 1, Libelle: "Nouveau" },
  { Id: 2, Libelle: "Traitement en cours" },
  { Id: 3, Libelle: "Validé" }, 
  { Id: 4, Libelle: "Refusé" }, 
];
export const enum Type_Reponse_Message {
  Nouveau = 1,
  TraitementEnCours = 2,
  Valide = 3,
  Refuse = 4
}
/** ******** */


export const alerteaParaitreList = [
  { Id: 1, Libelle: "Pas de notifications" },
  { Id: 2, Libelle: "Notification par email : 1 / semaine (vendredi - 11H00)" },
  { Id: 3, Libelle: "Notification par email : 1 / jour (11H00)" },
];

export const enum alerte_aParaitre {
  PasDeNotifications = 1,
  NotificationEmailSemaine = 2,
  NotificationEmailJour = 3,
}





export const civiliteList = [
    { Id: 1, Libelle: "Monsieur" },
    { Id: 2, Libelle: "Madame" },
    { Id: 3, Libelle: "Autre" },
  ];

  

  export const typeCompteList = [
    { Id: 1, Libelle: "Utilisateur société" },
    { Id: 2, Libelle: "Administrateur société" },
    { Id: 3, Libelle: "Administrateur Electre" },
  ];

  export const enum Type_Compte {
    UtilisateurSociete = 1,
    AdministrateurSociete = 2,
    AdministrateurElectre = 3
  }


  export const typeCompteStatus = [
    { Id: 1, Libelle: "Actif" },
    { Id: 2, Libelle: "Inactif" },
  ];



  export const enum notice_disponibilite {
    Disponible=1,
    AParaitre=2,
    ReimpressionEnCours=3,
    ManqueProvisoirement=4,
    Epuise=5,
    ArretDeCommercialisation=6,
    PlusDistribué=7,
    ManqueProvisoirementRouge=8,
  }


  export const disponibiliteList = [
    { Id: 1, Libelle: "Disponible" },
    { Id: 2, Libelle: "A Paraître" },
    { Id: 3, Libelle: "Réimpression en cours" },
    { Id: 4, Libelle: "Manque provisoirement" },
    { Id: 5, Libelle: "Epuisé" },
    { Id: 6, Libelle: "Arrêt de commercialisation" },
    { Id: 7, Libelle: "Ne sera plus distribué"},
    //{ Id: 8, Libelle: "Manque provisoirement rouge" }, retiré #1276
  ];


  export enum KeyCloakRoles {
    ElectreBO = "electre_BO",
    ElectreFO = "electre_FO",
  }

  export const DEFAULT_LOCAL_STORAGE = "{\"Limit\":10,\"Offset\":0}"

  function parseDateStringWithFormat(dateString: string, format: string) {
    //return moment(dateString, format, true).isValid() ? moment(dateString, ["DD/MM/YYYY HH:mm:ss", moment.ISO_8601], true).toDate(): null;
    return moment(dateString, ["DD/MM/YYYY HH:mm:ss", moment.ISO_8601], true).toDate();
  }
  
  export function parseDateString(dateString: string) {
    const dateFormats = [
      "DD/MM/YYYY HH:mm:ss",
      "DD/MM/YYYY",
      "DD-mm-YYYY",
      "YYYY-MM-DDTHH:mm:ss",
      // Ajoutez d'autres formats ici
    ];
  
    let parsedDate = null;
  
    for (const format of dateFormats) {
      const date = parseDateStringWithFormat(dateString, format);
      if (date) {
        parsedDate = date;
        break; 
        // Sort de la boucle dès qu'un format correspondant est trouvé
      }
    }
  
    // Si parsedDate est toujours null, le format de la date est inconnu
    if (!parsedDate) {
      // Vous pouvez choisir de renvoyer null ou la chaîne d'origine
      // Renvoyer la chaîne d'origine :
      parsedDate = dateString;
    }
    return parsedDate;
  }
  

export const TYPES_COMPTE_Inscription = [
  { Id: 1, Libelle: "Editeur" },
  { Id: 2, Libelle: "Diffuseur / Distributeur" },
  { Id: 4, Libelle: "Autre périmètre" },
];

/**
 * États d'une demande d'inscription
 */
export const ETATS_DEMANDE = {
  CREE: 1,
  VALIDE: 2,
  EN_COURS: 3,
  AFFECTATION_MARQUES: 4,
  REFUSE: 5
} as const;

 export const statutsListInscription = [
    { Id: 1, Libelle: "Nouveau" },
    { Id: 2, Libelle: "Validé" },
    { Id: 3, Libelle: "En cours de traitement" },
    { Id: 4, Libelle: "Affectation Marques" },
    { Id: 5, Libelle: "Refusé" },
  ];
